import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { MoodOption } from '@/data/moodActivities';
import { icons } from 'lucide-react';

interface MoodCardProps {
  mood: MoodOption;
  onSelect: () => void;
}

const MoodCard: React.FC<MoodCardProps> = ({ mood, onSelect }) => {
  const IconComponent = icons[mood.iconName as keyof typeof icons];

  return (
    <Card
      onClick={onSelect}
      className={cn(
        'cursor-pointer border transition-all duration-300 hover:scale-105',
        'flex flex-col items-center justify-center gap-3 p-6',
        'hover:shadow-lg bg-white',
        mood.borderClass
      )}
    >
      <div className={cn('flex items-center justify-center w-16 h-16 rounded-full', mood.iconBg)}>
        {IconComponent && <IconComponent className={cn('h-9 w-9', mood.colorClass)} />}
      </div>
      <span className={cn('font-semibold text-sm text-gray-900')}>
        {mood.label}
      </span>
    </Card>
  );
};

export default MoodCard;
